module.exports = __webpack_public_path__ + "static/img/tips.8ebf0105.svg";